import { createFileRoute } from '@tanstack/react-router';
import { RolesTab } from '../../../features/B1/roles-tab';

export const Route = createFileRoute('/_app/settings/roles')({
  component: RolesTab,
});
